import { extendObservable, observable } from 'mobx';
import moment from 'moment-timezone';
import Signage from '../../models/Signage';
import Location from '../../models/Location';
import Space from '../../models/Space';
import Availability from '../../models/Availability';
import User from '../../models/User';
import Demand from '../../models/Demand';
import config from "../../signage-config";
import FloorElement from '../../models/FloorElement';
import Vertices from '../../models/Vertices';
import spaceVertexMapping from '../../models/spaceVertexMapping';
import Edge from '../../models/Edge';
import FloorElementStartPoint from '../../models/FloorElementStartPoint';
import SpaceFloorElement from '../../models/SpaceFloorElement';
import liveDataUtil from 'wf-utils/data/live';
import dataTypes from 'wf-utils/data/types';
import spotAssetMapping from 'wf-utils/data/spot-asset-mapping';
import stateLogger from '../../utils/StateLogger';
class SignageState {
  client;

  realtime;

  debug;

  constructor(client, realtime, debug) {
    this.client = client;
    this.realtime = realtime;
    this.debug = debug;
    this.officeTime = {
      startTime: '07:00',
      endTime: '19:00',
      timeZone: '',
    };
    this.bufferTime = 1;
    this.socketHeartbeatTime = Date.now();

    extendObservable(this, {
      occupancyGraph:[],
      isLoading: true,
      pathWay: false,
      keyboardInvoked: false,
      parentLocation: null,
      showSidePanel: false,
      isFireMarshal: 0,
      showCurrentDayPlan: false,
      announcementCount : 0,
      announcementData:[],
      announcementCasheData:[],
      signage: null,
      showToast: false,
      spaces: [],
      categoryMap: {},
      locations: [],
      spaceMapping: [],
      userRequests: [],
      firemarshalData:[],
      Graph: {},
      healthStatusIndex: -1,
      floorElements: {},
      meetingRoomData:{},
      currentAnimation: 'stop',
      minimalMode: true,
      selectedElement: false,
      currentSignageId: null,
      loadEvents: false,
      socketEventInterval: null,
      actionPosition: {
        x: null,
        y: null,
        lastChange: false,
        update: null,
      },
      allSpaceAvailabilityReset: Math.random(),
      get colonies() {
        if (this.isLoading) {
          return [];
        }

        const categories = this.signage.categories.filter(c => c.showInWidget);
        categories.forEach(c => c.color = this.catMap[c.id]);
        // categories.forEach(category => { category.color = this.categoryMap[category.id]; });
        const categoryIds = categories.map(c => c.id);

        const colonies = {};

        this.locations.forEach(l => {
          const colony = {
            name: l.name,
            shortName: l.shortName,
            id: l.id,
            total: 0,
            availability: {},
          };
          categories.forEach(c => {
            colony.availability[c.id] = new Availability(c.name, c.color);
          });
          colonies[l.id] = colony;
        });

        this.spaces.forEach(space => {
          if (!space.category || !categoryIds.includes(space.category.id) || !space.senses.availability) {
            return;
          }

          colonies[space.locationId].availability[space.category.id].add(space.senses.availability.state);
          colonies[space.locationId].total += 1;
        });

        return [this.signage.locationId, ...this.signage.alternateLocationIds].filter(id => Object.prototype.hasOwnProperty.call(colonies, id)).map(id => {
          const { name, shortName, total, availability } = colonies[id];
          return {
            id,
            name,
            shortName,
            total,
            availability: categoryIds.map(id => availability[id]),
          };
        });
      },
    });
    // this.getMeetingRoom()
    setInterval(this.checkHeartBeat.bind(this), 2 * 1000);
    // This is harmless operation as updates will be ignored if there are no spaces
    this.realtime.subscribe(update => this.updateSpaceStateFromLegacyServer(update))
    this.realtime.sendSocketHeartbeat(time => { this.socketHeartbeatTime = time; });
  }


  liveSignageOnchange = (value) => {
    const { dataType, spaceId, data } = value;
    
    // Log modern socket update
    stateLogger.logSocketUpdate('liveDataUtil', value, {
      locationIds: this.signage ? [this.signage.locationId, ...this.signage.alternateLocationIds] : [],
      currentSignageId: this.currentSignageId
    });
    
    this.updateSpaceStateFromServer(value);
  }

  async getLiveSignageData(locationIds) {
    try {
      const subscription = await liveDataUtil.subscribe({
        xAuthKey: this.realtime.authKey,
        locationIds: locationIds,
        dataTypes: [dataTypes.OCCUPANCY_POLICY, dataTypes.CHECKIN],
        baseUrl: this.realtime.baseUrl,
        wsUrl: 'wss://spot-wss.afreespace.com',
        onConnect: () => {
           console.log('connected', this.getLiveSignageData);
        },
        onChange: (value) => this.liveSignageOnchange(value),
        heartbeatInterval: 60000
      });


      return subscription;
    } catch (e) {
      // console.log(e);
    }
  }




  async showSignage(signageId) {
    this.isLoading = true;
    this.spaces = [];
    this.locations = [];
    this.spaceMapping = [];
    this.userRequests = [];
    this.signage = null;
    this.parentLocation = null;
    this.catMap = config.catMap;
    this.isSpaceMeetingRoom = true;
    this.pathWay = false;
    this.currentElement = '';
    this.searchingElement = false;
    this.currentSignage = true;
    this.keyboardInvoked = false;
    this.minimalMode = false;
    this.currentAnimation = 'stop';
    this.lastAnimation = 'stop';
    this.allSpaceAvailabilityReset = Math.random();
    this.installedSignageId = signageId;
    this.installedLocationId = null;
    this.currentSignageId = signageId;
    this.keyboardPosition = 'top';
    this.svgCircleFill = '#fff';
    this.actionPosition = {
      x: null,
      y: null,
      lastChange: false,
      update: null,
    };
    this.spotFloors = config.spotFloors;
    this.nonSpotFloors = config.nonSpotFloors;
    // this.imageLoadOnStart = true;
    this.signageMap = config.signageMap;
    // console.log('Attempting to load signage ...');

    try {
      await Promise.all(
        Object.keys(this.signageMap).map(async signage => {
          if (this.signageMap[signage] !== this.installedSignageId) {
            const remaingsignageId = this.signageMap[signage];
            return Promise.all([
              this.loadSignage(remaingsignageId),
              this.loadGraph(remaingsignageId),
              this.loadAllElements(remaingsignageId),
            ]);
          }
          return true;
        }),
      );
      await this.loadSignage(signageId);
      // console.log('signage id', signageId);
      this.installedLocationId=this.signage.locationId;
      const locationIds = [this.signage.locationId, ...this.signage.alternateLocationIds];
      this.realtime.destinations = locationIds.map(locationId => `/t/L${locationId}/pe`);
      // await this.loadCategories();

      await Promise.all([
        this.loadLocations(locationIds),
        this.loadGraph(signageId),
        this.loadAllElements(signageId),
        this.loadSpaces(locationIds),
        // this.loadSpacesMapping(locationIds),

      ]);
      this.getLiveSignageData(locationIds);
      await this.loadSpaceStates(locationIds);
      await this.loadHistoricDemand(locationIds);
      await this.loadUserAmenityRequests(this.parentLocation);
      await this.realtime.connect();
      if (window.navigator.onLine) {
        setInterval(() => {
          const result = this.updateSpaceState();
          // console.log('result',result)
          if (result) {

            if (window.navigator.onLine) {
            this.loadSpaceStates(locationIds);
            this.loadUserAmenityRequests(this.parentLocation);
            }
          }
        }, 30 * 1000);

      }
      this.isLoading = false;
    } catch (e) {


      console.error(e);
      // console.log('Attempt to load signage failed. Will retry in 10 seconds');
      setTimeout(this.showSignage.bind(this), 60000, signageId);
    }
  }

  checkHeartBeat(id) {
    return this.client.checkHeartBeat(id, this);
  }
  async loadHistoricDemand(locationIds) {
    const currentTime = Math.floor(Date.now()/(86400*1000))*86400;
    const fifteenDaysBack = currentTime - 15*86400;
    const locationParams = {
      endTzEpoch: currentTime,
      startTzEpoch: fifteenDaysBack,
      floorIds: locationIds,
      resolution: "time",
      atp:-1,
      ptp:5,
      startHour:7,
      endHour:19,
      daysOfTheWeek: [1,2,3,4,5],
      categoryNames:[],
      subCategoryNames:[],
      departmentNames:[],

    };
    return this.client.fetchHistoricDemand(locationParams).then(fetcheddemand => {
      this.occupancyGraph = fetcheddemand.map(fetcheddemand => Demand.fromJSON(this, fetcheddemand));
      });
  }





  loadCategories(id) {
    const catMap = this.categoryMap;
    return this.client.fetchCategories().then(categories => {
      categories.forEach(c => {
        catMap[c.id] = c.colorScheme;
      });
    });
  }

  static getTime(time, timeZone) {
    const [hour, minute] = time.trim().split(':');
    return moment.tz(timeZone).startOf('day').add(hour, 'hour').add(minute, 'minute');
  }

  updateSpaceState() {
    const { timeZone, endTime, startTime } = this.officeTime;
    if (timeZone === '') return true;
    const offset = parseInt(this.timeOffset, 10);
    const currentTime = moment.tz(timeZone).add(-offset / 1000.0, 'second');
    const heartbeatTime = moment.tz(this.socketHeartbeatTime, timeZone);
    const officeStartTime = SignageState.getTime(startTime, timeZone);
    const officeEndTime = SignageState.getTime(endTime, timeZone);
    if (currentTime.isBetween(officeStartTime.clone().subtract(this.bufferTime, 'hour'), officeEndTime.clone().add(this.bufferTime, 'hour'))) return true;
    if (Math.abs(heartbeatTime.diff(currentTime, 'minute')) > 5) return true;
    return false;
  }

  loadUserAmenityRequests(ids) {
    return this.client.fetchgetAmenityRequests(ids, moment().tz(this.officeTime.timeZone).format('YYYYMMDD'),'FIRE_MARSHAL').then(fetchedUserRequests => {

       this.firemarshalData = fetchedUserRequests.map(userReq => {
        return User.fromJSON (this, userReq)

       });;

      let tempuserRequests = fetchedUserRequests.map(userReq => {
       return User.fromJSON (this, userReq)

      });
      this.userRequests = tempuserRequests.map(userReq => {
        userReq.locationId = this.installedLocationId;

       return userReq;

      });
    });
  }

  loadSignage(id) {
    return this.client.fetchSignage(id).then(fetchedSignage => {
       // this.floorElements = [];
       this.signage = Signage.fromJSON(this, fetchedSignage);
       if(this.imageLoadOnStart){
        const img = new Image();
         // let search = window.location.search;
         // let params = new URLSearchParams(search);
         let SignageOnMs = window.location.hostname === "local.afreespace.com" ? true:false;
         img.src = SignageOnMs ? this.signage.localImageUrl : this.signage.imageUrl;
       }
       this.getMeetingRoom(fetchedSignage.locationId)
       return this.loadAllElements(id);
     });
   }

   getMeetingRoom = async (locationId)=> {
    const data =  await this.client.getMeetingRoom(locationId).then(data => data);
    this.meetingRoomData = JSON.stringify(data);
  }
  loadAllElements(id) {
    return this.client.fetchAllElementsByDisplayId(id, id).then(fetchedElements => {
      this.floorElements[id] = [];
      this.floorElements[id] = fetchedElements.map(fetchedElement => FloorElement.fromJSON(this, fetchedElement));
    });
  }

  loadLocations(ids) {
    return this.client.fetchLocations(ids).then(fetchedLocations => {
      this.locations = fetchedLocations.map(fetchedLocation => Location.fromJSON(this, fetchedLocation));
      if (this.locations[0] && this.locations[0].parentLocation) {
        this.parentLocation = this.locations[0].parentLocation;
      }
      if (this.locations[0] && this.locations[0].timings) {
        this.officeTime = this.locations[0].timings;
      }
    });
  }

  async loadSpacesMapping(locationIds) {
    this.spaceMapping = await spotAssetMapping(this.realtime.baseUrl, locationIds, this.realtime.authKey, console);
  }

  loadSpaces(locationIds) {
    return this.client.fetchSpacesByLocations(locationIds).then(fetchedSpaces => {
      // Log API update
      stateLogger.logApiUpdate('fetchSpacesByLocations', fetchedSpaces, {
        locationIds,
        filteredCount: fetchedSpaces.filter(s => s.category).length,
        totalCount: fetchedSpaces.length
      });
      
      const filteredSpaces = fetchedSpaces.filter(s => s.category);
      filteredSpaces.forEach(s => { if (s.category) s.category.color = this.catMap[s.category.id]; });
      this.spaces = observable(filteredSpaces.map(space => Space.fromJSON(this, space)));
      this.loadEvents = true;
      // const fetchedStates = filteredSpaces.map(s => this.getSampleEvent(s));
      // fetchedStates.forEach(this.updateSpaceStateFromServer);
    });
  }

  loadGraph(id) {
    return this.client.fetchGraphByDisplayId(id).then(fetchedGraph => {
      this.Graph[id] = {
        vertices: [],
        edges: [],
        spaceVertexMapping: [],
        floorelementstartpoint: [],
        spacefloorelement: [],
        you_are_here: {},
      };
      this.Graph[id].vertices = fetchedGraph.vertices.map(fetchedVertex => Vertices.fromJSON(this, fetchedVertex));
      this.Graph[id].spaceVertexMapping = fetchedGraph.spaceVertexMapping.map(fetchedVertex => spaceVertexMapping.fromJSON(this, fetchedVertex));
      this.Graph[id].edges = fetchedGraph.edges.map(fetchedEdge => Edge.fromJSON(this, fetchedEdge));
      this.Graph[id].floorelementstartpoint = fetchedGraph.floorelementstartpoints.map(fetchedFloorelementstartpoint => FloorElementStartPoint.fromJSON(this, fetchedFloorelementstartpoint));
      this.Graph[id].spacefloorelement = fetchedGraph.spacefloorelements.map(fetchedSpacefloorelement => SpaceFloorElement.fromJSON(this, fetchedSpacefloorelement));
      if (fetchedGraph.displayStartPoints.length) {
        this.Graph[id].you_are_here = fetchedGraph.displayStartPoints[0].startPoint;
      }
    });
  }

  loadSpaceStates(locationIds) {
    return this.client.fetchSpaceStatesByLocations(locationIds).then(fetchedStates => {
      // Log API update
      stateLogger.logApiUpdate('fetchSpaceStatesByLocations', fetchedStates, {
        locationIds,
        stateCount: fetchedStates.length,
        source: 'periodic_refresh'
      });
      
      fetchedStates.forEach((fstate) => this.updateSpaceStateFromLegacyServer(fstate));
    });
  }

  refactorLegacyDataStructure = (update) => {
    return {
      ...update,
      ["dataType"]: 4,
      ["data"]: {
        utcEpoch: update.utcEpoch,
        value: update.state ? "PRESENCE" : "ABSENCE"
      }
    }
  }

  updateSpaceStateFromServer = update => {
    const currentTime = new Date();
    const timeString = `${currentTime.getMinutes().toString().padStart(2, '0')}:${currentTime.getSeconds().toString().padStart(2, '0')}`;
    
    // Socket data received log
    console.log(`🔌 SOCKET ${timeString} - Raw Modern Data:`, {
      spaceId: update.spaceId,
      dataType: update.dataType,
      value: update.data?.value,
      utcEpoch: update.data?.utcEpoch,
      rawData: update
    });
    
    if (!this.spaces) {
      return;
    }
    const existingSpace = this.spaces.find(entry => entry.id === update.spaceId);
    if (!existingSpace) {
      console.log(`🔌 SOCKET ${timeString} - Space not found: ${update.spaceId}`);
      return;
    }
    
    // Capture old state for logging
    const oldState = existingSpace.senses ? JSON.parse(JSON.stringify(existingSpace.senses)) : {};
    
    existingSpace.applyUpdate(update);
    
    // Force MobX reactivity by creating new array reference
    this.spaces = [...this.spaces];
    
    // Socket data processed log
    console.log(`🔌 SOCKET ${timeString} - Processed for FloorPlan:`, {
      spaceId: existingSpace.id,
      spaceName: existingSpace.name,
      oldAvailability: oldState.availability?.state,
      newAvailability: existingSpace.senses?.availability?.state,
      category: existingSpace.category?.name,
      hasSrf: !!existingSpace.srf,
      willShowOnFloorPlan: !!(existingSpace.srf && existingSpace.category?.name === "Desk"),
      forcedArrayUpdate: true
    });
    
    // Log state change
    stateLogger.logStateChange(
      existingSpace.id,
      existingSpace.name,
      oldState,
      existingSpace.senses,
      'modern_socket'
    );
  }

  updateSpaceStateFromLegacyServer = update => {
    const currentTime = new Date();
    const timeString = `${currentTime.getMinutes().toString().padStart(2, '0')}:${currentTime.getSeconds().toString().padStart(2, '0')}`;
    
    // Socket data received log
    console.log(`🔌 SOCKET ${timeString} - Raw Legacy Data:`, {
      spaceId: update.spaceId,
      state: update.state,
      utcEpoch: update.utcEpoch,
      rawData: update
    });
    
    // Log legacy socket update
    stateLogger.logSocketUpdate('FreespaceRealtime', update, {
      originalUpdate: JSON.parse(JSON.stringify(update))
    });
    
    update = this.refactorLegacyDataStructure(update);
    if (!this.spaces) {
      return;
    }

    const existingSpace = this.spaces.find(entry => entry.id === update.spaceId);
    if (!existingSpace) {
      console.log(`🔌 SOCKET ${timeString} - Space not found: ${update.spaceId}`);
      return;
    }
    
    // Capture old state for logging
    const oldState = existingSpace.senses ? JSON.parse(JSON.stringify(existingSpace.senses)) : {};
    
    //if (!this.spaceMapping.some(spm => spm.spaceId === existingSpace.id)) {
    existingSpace.applyUpdate(update);
    //}
    
    // Force MobX reactivity by creating new array reference
    this.spaces = [...this.spaces];
    
    // Socket data processed log
    console.log(`🔌 SOCKET ${timeString} - Processed for FloorPlan:`, {
      spaceId: existingSpace.id,
      spaceName: existingSpace.name,
      oldAvailability: oldState.availability?.state,
      newAvailability: existingSpace.senses?.availability?.state,
      category: existingSpace.category?.name,
      hasSrf: !!existingSpace.srf,
      willShowOnFloorPlan: !!(existingSpace.srf && existingSpace.category?.name === "Desk"),
      forcedArrayUpdate: true
    });
    
    // Log state change
    stateLogger.logStateChange(
      existingSpace.id,
      existingSpace.name,
      oldState,
      existingSpace.senses,
      'legacy_socket'
    );
  }

  getSampleEvent(s) {
    s.category.color = this.categoryMap[s.category.id];
    return {
      id: s.id,
      spaceId: s.id,
      tzEpoch: Date.now() / 1000 - 86400,
      utcEpoch: Date.now() / 1000 - 86400,
      state: 0,
      /* Simulation: s.id%2 */
      createdAt: '2018-06-13T05:58:34.000+0000',
      source: 'POLICY',
    };


  }
}

export default SignageState;
